function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-sticky-header-links\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.08,23.32H3.92a2.78,2.78,0,0,1-2.78-2.79v-12A2.78,2.78,0,0,1,3.92,5.77H36.08a2.79,2.79,0,0,1,2.79,2.78v12A2.79,2.79,0,0,1,36.08,23.32ZM3.92,8a.53.53,0,0,0-.53.53v12a.53.53,0,0,0,.53.54H36.08a.54.54,0,0,0,.54-.54v-12A.54.54,0,0,0,36.08,8Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.82,15.67H7.07a1.13,1.13,0,0,1,0-2.25h3.75a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.88,15.67H18.12a1.13,1.13,0,0,1,0-2.25h3.76a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.93,15.67H29.18a1.13,1.13,0,1,1,0-2.25h3.75a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20,33.77a1.14,1.14,0,0,1-1.13-1.13V19.11a1.13,1.13,0,1,1,2.25,0V32.64A1.13,1.13,0,0,1,20,33.77Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20,33.77A2.53,2.53,0,0,1,18.21,33l-3.58-3.58a1.12,1.12,0,0,1,0-1.59,1.13,1.13,0,0,1,1.6,0l3.57,3.57a.28.28,0,0,0,.4,0l3.57-3.57a1.13,1.13,0,0,1,1.6,0,1.12,1.12,0,0,1,0,1.59L21.79,33A2.53,2.53,0,0,1,20,33.77Z",
  fill: "#231f20"
});

function SvgCmsStickyHeaderLinks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgCmsStickyHeaderLinks;